"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.returns = void 0;
var utils_1 = require("../../utils");
exports.returns = function (axios) {
    return {
        /** @deprecated postReturnsPredictV2 사용해주세요 */
        postReturns: function (request) {
            return axios.post('/returns', request.data);
        },
        // 반품신청
        postReturnsV2: function (request) {
            return axios.post('/returns', request.data);
        },
        /** @deprecated postReturnsPredictV2 사용해주세요 */
        postReturnsPredict: function (request) {
            return axios.post('/returns/predict', request.data);
        },
        // 반품 예상금액 계산
        postReturnsPredictV2: function (request) {
            return axios.post('/returns/predict', request.data);
        },
        // 반품 수정
        putReturnsNo: function (request) {
            var url = utils_1.paramPathchange('/returns/{no}', request);
            return axios.put(url, request.data);
        },
        /** @deprecated 환불금액 조정 및 환불처리 */
        putReturnsNoAdjustConfirm: function (request) {
            var url = utils_1.paramPathchange('/returns/{no}/adjust-confirm', request);
            return axios.put(url, request.data);
        },
        // 환불금액 조정 및 환불처리 v2
        putReturnsNoAdjustConfirmV2: function (request) {
            var url = utils_1.paramPathchange('/returns/{no}/adjust-confirm', request);
            return axios.put(url, request.data);
        },
        // 반품철회 신청
        putReturnsNoApplyWithdraw: function (request) {
            var url = utils_1.paramPathchange('/returns/{no}/apply-withdraw', request);
            return axios.put(url, request.data);
        },
        // 반품승인
        putReturnsNoApprove: function (request) {
            var url = utils_1.paramPathchange('/returns/{no}/approve', request);
            return axios.put(url, request.data);
        },
        // 반품철회 승인
        putReturnsNoApproveWithdraw: function (request) {
            var url = utils_1.paramPathchange('/returns/{no}/approve-withdraw', request);
            return axios.put(url);
        },
        /** @deprecated 현금 환불 */
        putReturnsNoCashRefund: function (request) {
            var url = utils_1.paramPathchange('/returns/{no}/cash-refund', request);
            return axios.put(url, request.data);
        },
        // 현금 환불V2
        putReturnsNoCashRefundV2: function (request) {
            var url = utils_1.paramPathchange('/returns/{no}/cash-refund', request);
            var config = {
                headers: __assign({}, request.headers)
            };
            return axios.put(url, request.data, config);
        },
        // 반품수거 완료
        putReturnsNoCollect: function (request) {
            var url = utils_1.paramPathchange('/returns/{no}/collect', request);
            return axios.put(url, request.data);
        },
        // 반품을 변경할 경우 예상금액 계산
        postReturnsNoPredict: function (request) {
            var url = utils_1.paramPathchange('/returns/{no}/predict', request);
            return axios.post(url, request.data);
        },
        // 반품을 변경할 경우 예상금액 계산
        postReturnsNoPredictV2: function (request) {
            var url = utils_1.paramPathchange('/returns/{no}/predict', request);
            return axios.post(url, request.data);
        },
        // 반품주소 수정
        putReturnsNoReturnAddress: function (request) {
            var url = utils_1.paramPathchange('/returns/{no}/return-address', request);
            return axios.put(url, request.data);
        },
        // 반품철회
        putReturnsNoWithdraw: function (request) {
            var url = utils_1.paramPathchange('/returns/{no}/withdraw', request);
            return axios.put(url);
        }
    };
};
